import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken () {
    console.log('getToken')
    if (Cookies.get(TokenKey)) {
        return Cookies.get(TokenKey)
    } else {
        return 'Basic enV1bDp6dXVs'
    }

}

export function setToken (token) {
    console.log('setToken')
    return Cookies.set(TokenKey, token)
}

export function removeToken () {
    console.log('removeToken')
    return Cookies.remove(TokenKey)
    // return Cookies.set(TokenKey,'Basic enV1bDp6dXVs')
}
